/**
 * Import.
 *
 * @param {Object} params - Object parameter
 * @param {string} params.process - Kind of Import you want
 * @param {int} params.id - Identifier of the Import
 * @param {string} params.status - Status of the Import
 * @param {string} params.dest - URL of the Import
 * @constructor
 */

export default class Import {
    constructor({ id, process, report, details, url, data, logs, summary, status }) {
        this._id = id;
        this._process = process;
        this._report = report;
        this._details = details;
        this._data = data || {};
        this._url = url;
        this._logs = logs || [];
        this._summary = summary || {};
        this._status = status;
    }

    getID() {
        return this._id;
    }

    getDetails() {
        return this._details;
    }

    isDone() {
        return this._status === 'done';
    }

    getLogs() {
        return this._logs;
    }

    isValidating() {
        return this._status === 'new' || this._status === 'in-validation';
    }

    isConfirmable() {
        return this._status === 'valid' || this._status === 'not-valid';
    }

    countTotalRows() {
        return this.countCreatedRows() + this.countErrorRows();
    }

    countCreatedRows() {
        return this._logs.filter(({ type }) => type === 'created').reduce((count, { group, line }) => count + 1 + (line - group || 0), 0);
    }

    countErrorRows() {
        return this._logs.filter(({ type }) => type === 'invalid' || type === 'error').reduce((count, { group, line }) => count + 1 + (line - group || 0), 0);
        // line - group will be NaN if group is undefined
        // line is the last line of the group
        // group is the first line of the group
        // line count = group ? line - group + 1 : 1
    }

    getErrorCode({ code }) {
        return code;
    }

    getErrorGroups() {
        return this._logs
            .filter(({ type }) => type === 'invalid')
            .reduce((lines, current) => {
                let line_nb = current.line;
                lines[line_nb] = lines[line_nb] || [];
                lines[line_nb].push(current.error);
                return lines;
            }, {});
    }
}
